import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { CTAButton } from './CTAButton';
import { CheckIcon } from 'lucide-react';
const items = [{
  image: 'https://cdn.magicpatterns.com/uploads/gSF2vXRe6qeZsfde2hd5jZ/mk-01.png',
  title: 'La Biblia Nano-Creative',
  value: '$47',
  isMain: true
}, {
  image: 'https://cdn.magicpatterns.com/uploads/q8SdPgKcrt93unfuX2Ne19/B-01.png',
  title: 'BONO 1: La Bóveda de 100+ Prompts de Oro',
  value: '$97'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/89aNczTmimwjqZNoSNY5sR/B-02.png',
  title: 'BONO 2: Manual de Espionaje Ads Library',
  value: '$67'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/edkoswkbFEYuN797TnZfcg/B-03.png',
  title: 'BONO 3: El Plan de Acción de 30 Días',
  value: '$47'
}];
export function ValueStackSection() {
  return <AnimatedSection className="px-4 py-8 md:py-14" data-id="element-115">
      <div className="max-w-4xl mx-auto" data-id="element-116">
        <h2 className="font-playfair text-2xl md:text-4xl font-bold text-center mb-4" data-id="element-117">
          Todo lo que <span className="text-[#d4a853]" data-id="element-118">recibirás</span> hoy
        </h2>
        <p className="text-gray-400 text-center mb-6 md:mb-8 text-sm md:text-base" data-id="element-119">
          Si te unieras a una mentoría privada conmigo, pagarías $500/hora. Pero
          hoy, quiero que tengas todo el arsenal por una fracción:
        </p>

        <div className="space-y-3 mb-8" data-id="element-120">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex items-center gap-4 md:gap-6 bg-[#111111] border border-[#1a1a1a] rounded-sm p-4 md:p-5" data-id="element-121">
              <img src={item.image} alt={item.title} loading="lazy" className="w-16 h-16 md:w-24 md:h-24 object-contain flex-shrink-0" data-id="element-122" />
              <div className="flex-1 min-w-0" data-id="element-123">
                <div className="flex items-center gap-2 mb-1" data-id="element-124">
                  <CheckIcon className="w-4 h-4 text-[#d4a853] flex-shrink-0" data-id="element-125" />
                  <h3 className="text-white font-semibold text-sm md:text-base truncate" data-id="element-126">
                    {item.title}
                  </h3>
                </div>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-127">
                <p className="text-gray-500 text-xs tracking-wider uppercase" data-id="element-128">
                  Valor
                </p>
                <p className="text-[#d4a853] font-bold text-lg md:text-xl" data-id="element-129">
                  {item.value}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Pricing */}
        <div className="text-center border border-[#d4a853]/30 rounded-sm p-6 md:p-10 bg-[#111111] relative overflow-hidden" data-id="element-130">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-40 bg-[#d4a853]/5 blur-[80px] pointer-events-none" data-id="element-131" />
          <p className="text-gray-400 text-sm tracking-widest uppercase mb-2" data-id="element-132">
            Valor Total
          </p>
          <p className="text-3xl md:text-4xl font-bold text-gray-500 line-through mb-4" data-id="element-133">
            $258.00
          </p>
          <p className="text-[#d4a853] text-sm tracking-widest uppercase mb-2" data-id="element-134">
            Tu Precio Hoy
          </p>
          <p className="font-playfair text-5xl md:text-7xl font-bold text-white gold-text-shadow mb-6" data-id="element-135">
            $11.99
          </p>
          <CTAButton data-id="element-136" />
        </div>
      </div>
    </AnimatedSection>;
}